"use client";

import { useEffect, useState } from "react";
import { getSafeEmbed } from "@/lib/resources/embed";

export default function ResourceEmbed({ value, title = "Embedded resource", className }) {
  const [embed, setEmbed] = useState(undefined);
  useEffect(() => { setEmbed(getSafeEmbed(value)); }, [value]);
  if (embed === undefined) return <p role="status">Loading embedded resource…</p>;
  if (!embed) return <p role="status">This embed is not supported. Ask a studio administrator to add a supported video or document link.</p>;
  if (embed.srcdoc) {
    // An authored page runs in an opaque origin: its scripts see no cookies,
    // storage or parent document, and cannot navigate out of the frame. They
    // can still make requests of their own, with nothing of the app's to send.
    return <iframe
      srcDoc={embed.srcdoc}
      title={title}
      className={className || "h-[75vh] w-full border-0"}
      sandbox="allow-scripts"
      referrerPolicy="no-referrer"
      loading="lazy"
    />;
  }
  return <iframe
    src={embed.src}
    title={title}
    className={className || "aspect-video w-full border-0"}
    sandbox="allow-scripts allow-same-origin allow-presentation"
    allow="fullscreen; picture-in-picture"
    referrerPolicy="no-referrer"
    loading="lazy"
    allowFullScreen
  />;
}
